import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesDeliveryFees } from "../../constants";
import { ParcelSizes } from "../../financial.types";

export const requestUpdateParcelSizes = async (
  parcelSize: ParcelSizes
): Promise<void> => {
  return await instance.patch(buildUrl(ApiRoutesDeliveryFees.ParcelSizes), {
    parcelSize
  });
};
